
  import React from "react"
  import Component from "Z:/workspace/personalWebsite/src/layouts/index.jsx"
  import data from "Z:\\workspace\\personalWebsite\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js